// A2F-650: Step 4 custom rules.
//
// Empty state shows two illustrative cards so the user has a concrete
// picture of what a custom rule looks like before typing. Once they
// add a real rule the examples disappear — examples are a teaching
// device, not permanent furniture.
//
// The text box reuses FormattingTextBox with origin='custom_rules' so
// a format-shaped response routes via P3(a) cross-direction back to
// Step 2 (page-level handler).

import type {
  CustomRuleChip,
  FormattingPill,
} from '../../../lib/onboard-v2-formatting'
import { FormattingTextBox } from './FormattingTextBox'
import { RuleCard } from './RuleCard'

interface CustomRulesSectionProps {
  customRules: CustomRuleChip[]
  onAddPill: (pill: FormattingPill) => void
  onAddRule: (chip: CustomRuleChip) => void
  onRemoveRule: (id: string) => void
  domain: string
}

export function CustomRulesSection({
  customRules,
  onAddPill,
  onAddRule,
  onRemoveRule,
  domain,
}: CustomRulesSectionProps) {
  const hasRules = customRules.length > 0

  return (
    <div>
      <FormattingTextBox
        placeholder='e.g. flag "data is" as "data are"'
        buttonLabel="+ Add rule"
        domain={domain}
        origin="custom_rules"
        onAddPill={onAddPill}
        onAddRule={onAddRule}
      />

      <div className="mt-4">
        {hasRules ? (
          customRules.map((chip) => (
            <RuleCard
              key={chip.id}
              iconLetter={chip.status === 'coming_soon' ? '?' : 'S'}
              name={chip.label}
              description={chip.rule?.description ?? 'Pending translation'}
              status={chip.status}
              onRemove={() => onRemoveRule(chip.id)}
            />
          ))
        ) : (
          <>
            <RuleCard
              iconLetter="S"
              name="Grammar: data are"
              description='Flags "data is" — regulatory convention treats "data" as plural'
              status="example"
            />
            <RuleCard
              iconLetter="S"
              name="Placeholder scan"
              description='Flags TBD, [INSERT], and "to be determined" text'
              status="example"
            />
          </>
        )}
      </div>
    </div>
  )
}
